// store/exercices/createExercicesSlice.ts

import { StateCreator } from 'zustand';
import { Emprunt } from '../../types';
import { empruntsInitialState, EmpruntsState } from './empruntsInitialState';
export type AddAccountVisibility =
  | 'show_in_emprunt_page'
  | 'show_in_emprunt_accounts'
  | 'show_in_ecriture_page'
  | 'show_in_fnp_page'
  | 'hidden';

/**
 * @french
 * Interface des actions liées aux exercices comptables.
 */
export interface EmpruntsActions {
  setSelectedEmprunt: (
    updater: Emprunt | null | ((prev: Emprunt | null) => Emprunt | null),
  ) => void;
  setActiveTabKey: (activeTabKey: string) => void;
  reset: () => void;
}

/**
 * @french
 * Slice Zustand pour les actions liées aux exercices comptables.
 */
export const createExercicesSlice: StateCreator<
  EmpruntsState & EmpruntsActions,
  [],
  [],
  EmpruntsActions
> = (set, get) => ({
  setSelectedEmprunt: (updater) => {
    const current = get().selectedEmprunt;
    const next =
      typeof updater === 'function'
        ? (updater as (prev: Emprunt | null) => Emprunt | null)(current)
        : updater;

    set({
      selectedEmprunt: next,
      empruntVersion: get().empruntVersion + 1, // ★ incrément
    });
  },
  setActiveTabKey: (activeTabKey) => set({ activeTabKey }),
  reset: () => set(empruntsInitialState),
});
